import {z} from 'zod';

import {BaseVoidResponseSchema} from '@dms/api/shared';

export const PostHyundaiMobisIrisReportApiResponseSchema = BaseVoidResponseSchema;

export type PostHyundaiMobisIrisReportApiResponse = z.infer<
  typeof PostHyundaiMobisIrisReportApiResponseSchema
>;

export const PostHyundaiMobisIrisReportApiArgSchema = z.object({
  body: z.object({
    integrationCode: z.literal('HYUNDAI_MOBIS_IRIS'),
    startDate: z.string(),
    endDate: z.string(),
  }),
});

export type PostHyundaiMobisIrisReportApiArg = z.infer<
  typeof PostHyundaiMobisIrisReportApiArgSchema
>;

export const PostMercedesMraReportApiResponseSchema = BaseVoidResponseSchema;

export type PostMercedesMraReportApiResponse = z.infer<
  typeof PostMercedesMraReportApiResponseSchema
>;

export const PostMercedesMraReportApiArgSchema = z.object({
  body: z.object({
    reportName: z.string(),
    dateFrom: z.string(),
    dateTo: z.string(),
  }),
});

export type PostMercedesMraReportApiArg = z.infer<typeof PostMercedesMraReportApiArgSchema>;

export const PostMercedesMraInactiveReportApiResponseSchema = BaseVoidResponseSchema;

export type PostMercedesMraInactiveReportApiResponse = z.infer<
  typeof PostMercedesMraInactiveReportApiResponseSchema
>;

export const PostMercedesMraInactiveReportApiArgSchema = z.object({
  body: z.object({
    status: z.string(),
    dateFrom: z.string(),
    dateTo: z.string(),
    reason: z.string(),
    name: z.string(),
  }),
});

export type PostMercedesMraInactiveReportApiArg = z.infer<
  typeof PostMercedesMraInactiveReportApiArgSchema
>;

export const Post5StarReportApiResponseSchema = z.array(
  z.object({
    fileLink: z.string(),
    fileId: z.string(),
  })
);

export type Post5StarReportApiResponse = z.infer<typeof Post5StarReportApiResponseSchema>;

export const Post5StarReportApiArgSchema = z.object({
  body: z.array(
    z.object({
      dateFrom: z.string(),
      dateTo: z.string(),
      reportCars: z.boolean(),
      authorizationProfile: z.string(),
    })
  ),
});

export type Post5StarReportApiArg = z.infer<typeof Post5StarReportApiArgSchema>;

export const Get5StarCstarBranchesApiResponseSchema = z
  .array(
    z.object({
      branchName: z.string().nullish(),
      authorizationProfileId: z.string().nullish(),
    })
  )
  .nullish();

export type Get5StarCstarBranchesApiResponse = z.infer<
  typeof Get5StarCstarBranchesApiResponseSchema
>;

export const Get5StarCstarBranchesApiArgSchema = z.object({
  type: z.enum(['5star', 'cstar']),
});

export type Get5StarCstarBranchesApiArg = z.infer<typeof Get5StarCstarBranchesApiArgSchema>;

export const PostMechanicCompensationApiResponseSchema = BaseVoidResponseSchema;
export type PostMechanicCompensationApiResponse = z.infer<
  typeof PostMechanicCompensationApiResponseSchema
>;

export const PostMechanicCompensationApiArgSchema = z.object({
  body: z.object({
    mechanicPaids: z.array(
      z.object({
        mechanicId: z.string(),
        serviceOrderJobItemId: z.string(),
        isPaid: z.boolean().optional(),
        note: z.string().optional(),
      })
    ),
  }),
});
export type PostMechanicCompensationApiArg = z.infer<typeof PostMechanicCompensationApiArgSchema>;
